<div class="suggest-container" [ngClass]="rootClassName">
  <div class="suggest-container1">
    <div class="suggest-navigationbar">
      <div class="suggest-title">
        <div class="frame8pxspacer"></div>
        <div class="suggest-col3">
          <div class="suggest-col4">
            <span class="suggest-text01 headingboldlarge">
              <span>Have a suggestion?</span>
            </span>
          </div>
        </div>
        <div class="frame8pxspacer"></div>
      </div>
    </div>
    <div class="suggest-content1">
      <div class="frame16pxspacer"></div>
      <div class="suggest-row">
        <div class="suggest-col5">
          <span class="suggest-text03 labelregularsmall">
            <span>Share your ideas on how we can improve your experience.</span>
          </span>
        </div>
      </div>
      <div class="frame40pxspacer"></div>
      <div class="suggest-row1">
        <div class="suggest-select">
          <span class="suggest-text05 labelregularmedium">
            <span>Give us your suggestion:</span>
          </span>
          <div class="suggest-text-block">
            <span class="suggest-text07 labelregularmedium">
              <span>-- Please Select --</span>
            </span>
            <img
              src="/assets/icons/mdiarrowdropdown.svg"
              alt="mdiarrowdropdownI648"
              class="suggest-mdiarrowdropdown"
            />
          </div>
        </div>
        <div class="frame24pxspacer"></div>
        <div class="suggest-text-area">
          <div class="suggest-title1">
            <span class="suggest-text09">
              <span>Description</span>
            </span>
            <span class="suggest-text11">*</span>
          </div>
          <div class="suggest-text-block1">
            <span class="suggest-text12 labelregularmedium">
              <span>
                <span>Hint text</span>
                <br />
                <span></span>
                <br />
                <span></span>
                <br />
                <span></span>
                <br />
                <span></span>
              </span>
            </span>
          </div>
        </div>
      </div>
      <div class="frame24pxspacer"></div>
      <div class="suggest-cta">
        <button class="suggest-buttonnew suggest-buttonmaster">
          <span class="suggest-text23 labelmediummedium">
            <span>Submit</span>
          </span>
        </button>
      </div>
      <div class="frame40pxspacer"></div>
    </div>
  </div>
</div>
